export const INSTITUTIONAL_EMAIL_DOMAINS = [
  "@professor.edu.pi.gov.br",
  "@aluno.edu.pi.gov.br",
];

export const isInstitutionalEmail = (email) =>
  INSTITUTIONAL_EMAIL_DOMAINS.some((domain) =>
    String(email).toLowerCase().endsWith(domain),
  );
